<template>
  <div>
    <v-card :class="!isFlat ? 'card-custom-shadow' : ''" :flat="isFlat">
      <v-card-text class="fs-12" :class="!isFlat ? '' : 'pa-0'">
        <div class="fs-14px black--text mb-2" v-if="!isFlat">Hoàn thành</div>

        <div class="text-center my-5">
          <img
            style="height: 150px"
            :src="require('@/assets/common/check.png')"
            alt=""
          />
        </div>

        <div class="text-center">
          <span v-if="type == 'branch'">
            Hãy bàn giao tài sản và tiếp tục công việc nhé!
          </span>
          <span v-else>
            Yêu cầu đặt xe đã hoàn thành
          </span>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { ORDER_CREATE_DEFAULT_CONTRACT } from "@/libs/const";

export default {
  name: "Success",
  props: {
    info: {
      type: Object,
      default: () => {},
    },
    summary: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String,
      default: () => "branch",
    },
    isFlat: {
      type: Boolean,
      default: () => false,
    },
  },
  data: () => ({
    order: { ...ORDER_CREATE_DEFAULT_CONTRACT },
    file: null,
  }),
  watch: {
    order: {
      handler() {
        this.$emit("onUpdate", this.order);
      },
      deep: true,
    },
  },
  computed: {},
  mounted() {},
  methods: {
    onReset() {
      this.order = { ...ORDER_CREATE_DEFAULT_CONTRACT };
    },
    goBack() {
      this.$emit("goBack", true);
    },
    onInputFileChange() {},
  },
};
</script>
